//import Swiper from '/_assets/node_modules/swiper/swiper-bundle.min.mjs';

export function initSwiper(selector) {

    import(/* webpackChunkName: "wp-swiper-bundle" */ 'swiper/bundle').then(SwiperModule => {

        const Swiper = SwiperModule.default;

        selector.forEach((element) => {
            new Swiper(element, {
                loop: true,
                effect: 'fade',
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                slidesPerView: 1,
                initialSlide: 0,
            });
        });
    });
}
